import { Directive, HostListener } from '@angular/core'

@Directive({
  selector: '[libPreventSubmitOnEnter]',
})
export class PreventSubmitOnEnterDirective {
  @HostListener('keydown', ['$event'])
  public onKeydown(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      event.preventDefault()
      event.stopPropagation()
    }
  }
}
